import EntityDashboardState, { EntityDashboardListItemState } from '../../state/EntityDashboardState';
import React from 'react';
import SelectedFilters from '../dashboardWidgets/SelectedFilters';
import { Stack, StackItem } from '@fluentui/react/lib/Stack';
import FiltersPanel from '../controls/FilterPanel';
import {
	CommandBar,
	ICommandBarItemProps,
} from '@fluentui/react/lib/CommandBar';
import {
	DetailsListLayoutMode,
	IColumn,
	Label,
	mergeStyleSets,
	SelectionMode,
	Spinner,
	Selection,
	Checkbox,
	Icon,
	Text,
	Dialog,
	DialogType,
	DialogFooter,
	DefaultButton,
	PrimaryButton
} from '@fluentui/react';
import { observer } from 'mobx-react';
import {
	FieldType,
	ICustomFieldValue,
	IEntityColumn,
	IGenericEntity,
} from '../../API';
import { VersionHistory } from '../controls/VersionHistory';
import ViewsCtrl, { ViewsCtrlRenderFormat } from '../controls/ViewsCtrl';
import CurrencySelect from '../controls/CurrencySelect';
import PeoplePickerCtrl from '../controls/PeoplePickerCtrl';
import { IUserConfigPackage } from '../../API';
import FormField from '../forms/FormField';
import SearchCtrl, { SearchCtrlStyle } from '../controls/SearchCtrl';
import ScrollableDetailsList from '../controls/ScrollableDetailsList';
import EntityItemFavouriteButton from '../controls/EntityItemFavouriteButton';

interface IEntityDashboardProps {
	state: EntityDashboardState;
	onItemInvoked?: (item: IGenericEntity) => void;
	onSelectionChanged?: (items: IGenericEntity[]) => void;
}

const classNames = mergeStyleSets({
	tasksSummaryTableRow: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
	},
});

class EntityDashboard extends React.Component<IEntityDashboardProps, {}> {
	private columnSelectorIcon =
		'columnSelectorButton' + Math.random().toString().replace('.', '');

	componentDidMount() {
		this.props.state.ensureLoaded();
	}

	render() {
		return (
			<Stack>
				<FiltersPanel state={this.props.state.filtersState} />
				{this.headerBar()}
				{this.searchBar()}
				{this.versionHistoryDialog()}
				<div>{this.widgetContent()}</div>
			</Stack>
		);
	}

	private versionHistoryDialog() {
		if (this.props.state.versionHistoryState !== null) {
			return <VersionHistory state={this.props.state.versionHistoryState} />;
		}
	}

	private hasData() {
		return this.props.state.items && this.props.state.items.length > 0;
	}

	private searchBar() {
		return <SearchCtrl
				initialValue={this.props.state.searchText}
				style={SearchCtrlStyle.Standard}
				placeholder={'Search ' + this.props.state.entityTypeConfig.pluralName.toLowerCase() + '...'}
				onSearchTextChanged={(searchText: string) => {
					this.props.state.setSearchText(searchText);
				}}
			/>;
	}

	private headerBar(): React.ReactNode {
		let addOrEditButtons:ICommandBarItemProps[] = [];

		//The add button should be blue
		addOrEditButtons.push({
			key: 'addTaskButton',
			onRender: () => {
				return <PrimaryButton 
					style={{ height: 22, marginTop: 5, marginRight:10 }}
					iconProps={{ iconName: 'Add' }}
					onClick={() => {
						this.props.state.showNewForm();
					}}>New {this.props.state.entityTypeConfig.singularName}</PrimaryButton>;
			}
		});

		if (this.props.state.items.filter((i) => i.isSelected).length === 1) {
/*
			let item = this.props.state.items.filter((i) => i.isSelected)[0];

			let label = 'View';

			addOrEditButtons.push({
				key: 'editButton',
				text: label,
				title: label,
				iconProps: { iconName: label },
				onClick: () => {
					this.props.state.showEditForm(item.Id);
				},
			});
*/
			/*
			if (this.props.state.versionHistoryState !== null) {
				projectButtons.push({
					key: 'versionHistoryButton',
					text: 'Version history',
					title: 'Version history',
					iconProps: { iconName: 'History' },
					onClick: () => {
						this.props.state.versionHistoryState?.show(item.Id);
					},
				});
			}*/
		}

		/*
		if (this.props.state.items.filter((i) => i.isSelected).length > 1) {
			projectButtons.push({
				key: 'deleteAllButton',
				text: 'Delete',
				title: 'Delete',
				iconProps: { iconName: 'Delete' },
				onClick: () => {
					this.props.state.toggleDeleteConfirmDialog(true);
				},
			});
		}*/

		return (
			<>
				{this.getDeleteDialog()}

				<Stack
					horizontal
					horizontalAlign={'space-between'}
					verticalAlign="center"
					key={'teamdashboard-main'}
				>

					<Stack.Item>
						<ViewsCtrl
							state={this.props.state.viewsState}
							renderFormat={ViewsCtrlRenderFormat.Pivot}
						/>
					</Stack.Item>
					<Stack.Item grow>&nbsp;</Stack.Item>

					<Stack.Item key={'stackitemfilters'}>
						<SelectedFilters
							userConfig={this.props.state.userConfig}
							filters={this.props.state.filtersState}
						/>
					</Stack.Item>

					<Stack.Item key={'rightdbcommandbar'}>
						<CommandBar items={[]} farItems={addOrEditButtons.concat(this.getRightCommandBarItems())} />
{/*
						<Callout
							hidden={!this.props.state.showColumnSelector}
							role="dialog"
							onDismiss={() => {
								this.props.state.toggleShowColumnSelector();
							}}
							target={'#' + this.columnSelectorIcon}
						>
							{this.getColumnSelector()}
						</Callout>
*/}						
					</Stack.Item>
				</Stack>
			</>
		);
	}

	getDeleteDialog() {
		return (
			<Dialog
				hidden={!this.props.state.showDeleteConfirmDialog}
				onDismiss={() => {
					this.props.state.toggleDeleteConfirmDialog(false);
				}}
				dialogContentProps={{
					type: DialogType.normal,
					title: 'Confirm deletion',
					subText: `Please confirm deletion of all ${this.props.state.items.filter((i) => i.isSelected).length} selected items. This is irreversible.`,
				}}
				modalProps={{
					isBlocking: true,
					styles: { main: { maxWidth: 450 } },
				}}
			>
				<DialogFooter>
					<DefaultButton
						onClick={() => {
							this.props.state.toggleDeleteConfirmDialog(false);
						}}
						text="Cancel"
					/>
					<PrimaryButton
						onClick={() => {
							this.props.state.confirmSelectedItemDeletion();
						}}
						text="Delete"
					/>
				</DialogFooter>
			</Dialog>
		);
	}

	private getRightCommandBarItems(): ICommandBarItemProps[] {
		let result: ICommandBarItemProps[] = [];

		result.push({
			key: 'editColumnsButton',
			title: 'Columns',
			text: 'Columns',
			iconProps: { iconName: 'Table' },
			ariaLabel: 'Modify columns',
			id: this.columnSelectorIcon,
			onClick: () => {
				this.props.state.toggleShowColumnSelector();
			},
		});

		if (this.props.state.filtersState.filterFields.length > 0) {
			result.push({
				key: 'openFilterPanelButton',
				title: 'Filter',
				text: 'Filter',
				iconProps: { iconName: 'Filter' },
				ariaLabel: 'Open Filter Options',
				onClick: () => {
					this.props.state.filtersState.toggleFilterPanel(true);
				},
			});
		}

		result.push({
			key: 'reloadButton',
			title: 'Reload data',
			iconProps: { iconName: 'Refresh' },
			ariaLabel: 'Reload data',
			onClick: () => {
				this.props.state.reload();
			},
		});

		return result;
	}

	private widgetContent(): React.ReactNode {
		return (
			<>
				{this.getItemList()}

				{this.getEmptyResultMessage()}

				{this.getLoadingSpinner()}
			</>
		);
	}

	private getLoadingSpinner(): React.ReactNode {
		if (this.props.state.loading) {
			return <Spinner></Spinner>;
		}
		return <></>;
	}

	private getEmptyResultMessage(): React.ReactNode {
		if (this.props.state.loaded && !this.props.state.loading && !this.hasData()) {
			if (
				this.props.state.searchText ||
				this.props.state.filtersState.selectedFilters.length > 0
			) {
				return <Label>There are no items matching your query.</Label>;
			} else {
				return <Label>There are no items to display.</Label>;
			}
		}
		return <></>;
	}

	private getItemList(): React.ReactNode {
		var columns = this._getColumns();

		columns.forEach((column) => {
			column.isSorted = this.props.state.sortField === column.fieldName;
			column.isSortedDescending = !this.props.state.sortAsc;
			column.onColumnClick = (_, c) => {
				if (c.fieldName === this.props.state.sortField) {
					this.props.state.setSorting(c.fieldName, !this.props.state.sortAsc);
				} else {
					//Set the sort direction to the default (ascending) and the field to the new field
					this.props.state.setSorting(c.fieldName || '', true);
				}
			};
		});

		return (
			<Stack horizontal className="dashboardOuter">
				<ScrollableDetailsList
					isHeaderVisible={true}
					layoutMode={DetailsListLayoutMode.fixedColumns}
					setKey="items"
					items={this.props.state.items}
					columns={columns}
					selectionMode={SelectionMode.none}
					selection={this.getSelection()}
					columnReorderOptions={{
						frozenColumnCountFromStart: 1,
						handleColumnReorder: (draggedIndex: number, targetIndex: number) => {
							const draggedItems = columns[draggedIndex];
							const newColumns: IColumn[] = [...columns];

							// insert before the dropped item
							newColumns.splice(draggedIndex, 1);
							newColumns.splice(targetIndex, 0, draggedItems);
							this.props.state.setTableDisplayColumns(newColumns.filter((c) => c.key !== 'pinnedIcon').map((c) => c.key));
						},
					}}
					ariaLabelForGrid="Item details"
				/>
			</Stack>
		);
	}

	getColumnSelector(): React.ReactNode {
		return (
			<Stack style={{ margin: 4 }}>
				{this.props.state.allColumns.map((c) => {
					return (
						<StackItem>
							<Stack horizontal>
								<StackItem style={{ padding: 4 }}>
									<Checkbox
										checked={
											this.props.state.tableDisplayColumnInternalNames.indexOf(c.id) > -1
										}
										onChange={(_, checked) => {
											this.props.state.setColumnViewable(c.id, !!checked);
										}}
										label={c.displayName}
									/>
								</StackItem>
							</Stack>
						</StackItem>
					);
				})}
			</Stack>
		);
	}

	getSelection(): Selection {
		let selection = new Selection({
			onSelectionChanged: () => {
				const selectedItems = selection.getSelection() as EntityDashboardListItemState[];
				this.props.state.setSelection(selectedItems);

				if (this.props.onSelectionChanged) {
					this.props.onSelectionChanged(selectedItems.map((i) => i.item));
				}
			},
		});

		return selection;
	}

	private _getColumns(): IColumn[] {
		let result: IColumn[] = [];

		result.push({
			key: 'pinnedIcon',
			name: '',
			fieldName: 'Id',
			minWidth: 20,
			maxWidth: 20,
			isResizable: false,
			onRender: (item: EntityDashboardListItemState) => {
				return <EntityItemFavouriteButton
					state={item}
					onToggle={() => this.props.state.togglePin(item)}
				/>;
			},
		});

		/*
		result.push({
			key: 'attachmentIcon',
			name: '',
			fieldName: 'hasAttachments',
			minWidth: 12,
			maxWidth: 12,
			isResizable: false,
			onRender: (item:IGenericEntity) => {
				return item.attachmentIds?.length ? <Icon title={'This ' + this.props.state.singularName + ' has files attached.'} iconName='Attach' /> : <></>;
			}
		})
*/

		for (let columnInternalName of this.props.state.tableDisplayColumnInternalNames) {
			let column = (this.props.state.allColumns || []).find(
				(c) => c.id.toLowerCase() === columnInternalName.toLowerCase(),
			);
			if (column) {
				result.push({
					key: column.id,
					name: column.displayName,
					fieldName: column.id,
					minWidth:
						Number(column.displayWidth) === 0 ? 75 : Number(column.displayWidth),
					maxWidth:
						Number(column.displayWidth) === 0 ? 75 : Number(column.displayWidth),
					isResizable: true,
					className: column.fieldType === FieldType.User ? 'userGridRowCell' : '',
					onRender: (item: EntityDashboardListItemState) => {
						if (column) {

							var fieldValue = item.getFieldValue(column.id);

							//If it's the title column, do some special rendering
							if(column.id === "Title" || column.id === "LinkTitle") {

								//Get the first column ending 'Code'
								let codeColName = this.props.state.tableDisplayColumnInternalNames.find(f => f.endsWith('Code'));
								let code = codeColName ? item.getFieldValue(codeColName) : undefined;

								return <div key={column.id} 
											style={{cursor:'pointer'}} 
											onClick={() => this.props.state.showEntityDialog(item)}>
									<strong>{fieldValue}</strong>
									
									{ code && <Stack horizontal tokens={{ childrenGap: 30 }}>
										{ <StackItem style={{fontSize:12}}>{code}</StackItem> }
									</Stack> }
								</div>;
							}


							if (fieldValue === undefined) {
								//Could be a custom field (we could verify by checking the name is a guid)
								fieldValue = (
									((item.item as any).custom as ICustomFieldValue[]) || []
								).find((v) => v.internalName === column?.id)?.internalValue;
							}

							if (fieldValue !== undefined) {
								fieldValue = this.getPropertyDisplayValue(
									item.item,
									column,
									fieldValue,
								);
							}

							if (fieldValue !== undefined) {
								return (
									<div key={column.id} className={classNames.tasksSummaryTableRow}>
										<span>{fieldValue}</span>
									</div>
								);
							}
						}
					},
				});
			}
		}

		return result;
	}

	private getPropertyDisplayValue(
		entity: IGenericEntity,
		column: IEntityColumn,
		internalValue: any,
	): React.ReactElement {
		if (internalValue === undefined || internalValue === null) return <></>;

		return EntityDashboard.displayPropertyValue(
			entity,
			this.props.state.userConfig,
			column,
			internalValue,
			true,
		);
	}

	public static displayPropertyValue(
		entity: IGenericEntity | null,
		userConfig: IUserConfigPackage,
		columnInfo: IEntityColumn,
		internalValue: string | number | boolean | Date | string[],
		small: boolean,
	): React.ReactElement {
		if (!columnInfo || !internalValue) {
			//We don't know how to render it or there's no value anyway.
			return <>{internalValue}</>;
		}

		//If it looks like a datetime, format it as such
		let intValueStr = (internalValue as string || '');
		if(typeof intValueStr === 'string' && intValueStr.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/) && (internalValue as string).length < 40) {
			try {
				return <Text>{new Intl.DateTimeFormat(navigator.language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(internalValue as string))}</Text>;
			} catch(e){
				console.log(e);
			}
		}

		if (columnInfo.id === 'durationMinutes') {
			return <>{(internalValue as string) + 'm'}</>;
		}

		if (columnInfo.fieldType === FieldType.Currency && entity) {
			//Attempt to get the currency from the entity
			let currency =
				(entity as any).currency ||
				(entity as any).kindOfShareCurrency; /* yes this is a bit of a hack */
			if (currency) {
				return (
					<Text>
						{CurrencySelect.getCurrencyFormatted(currency, internalValue as number)}
					</Text>
				);
			}
		}

		if (columnInfo.fieldType === FieldType.DateTime) {
			//It might be a date or it might be a days offset. If it's a date it could be a date instance or a string (which is more than 10 chars)
			if (
				internalValue instanceof Date ||
				(typeof internalValue === 'string' && internalValue.length > 10)
			) {
				return (
					<Text>
						{new Intl.DateTimeFormat(navigator.language).format(
							new Date(internalValue),
						)}
					</Text>
				);
			} else {
				return <Text>{internalValue} days</Text>;
			}
		} else if (columnInfo.fieldType === FieldType.User) {
			if (internalValue === '[me]') {
				return <Text>Me</Text>;
			} else {
				return (
					<PeoplePickerCtrl
						readonly={true}
						selectedIds={FormField.getPeopleIds(internalValue as string | string[])}
					/>
				);
			}
		} else if (columnInfo.fieldType === FieldType.Lookup) {
			
			if (typeof internalValue === 'string') {
				if (internalValue.length) {
					
				}
			} else {
				
			}

			return (
				<></>
			);
		} else if (columnInfo.fieldType === FieldType.Boolean) {
			if (FormField.getBoolean(internalValue as string)) {
				return (
					<Icon
						style={{ fontWeight: 'bold', fontSize: 18 }}
						iconName="Accept"
					></Icon>
				);
			} else {
				return <></>;
			}
		} else if (
			columnInfo.fieldType === FieldType.MultiChoice ||
			columnInfo.fieldType === FieldType.Choice
		) {
			return (
				<>
					{FormField.getChoices(internalValue as string).map((choice) => (
						<div key={'div' + choice}>{choice}</div>
					))}
				</>
			);
		} else if (columnInfo.fieldType === FieldType.CustomFieldType) {
			return <>{FieldType[internalValue as number]}</>;
		} else if (
			columnInfo.fieldType === FieldType.Number &&
			columnInfo.id.endsWith('Percent')
		) {
			internalValue = Number(internalValue).toFixed(1) + '%';
		}

		let style: any = {
			textWrap: 'wrap',
		};
		if (small) {
			style.fontSize = 12;
		}

		return <Text style={style}>{internalValue}</Text>;
	}
}

export default observer(EntityDashboard);
